import { render, staticRenderFns } from "./Favoritos.vue?vue&type=template&id=7b3f2340&"
import script from "./Favoritos.vue?vue&type=script&lang=js&"
export * from "./Favoritos.vue?vue&type=script&lang=js&"
import style0 from "./Favoritos.vue?vue&type=style&index=0&id=7b3f2340&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports